import React from 'react';

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';

export default function CalendlyDialog({
  open,
  onOpenChange,
  title,
  description,
  iframeTitle,
  src,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[96vw] h-[92dvh] max-w-none sm:w-[min(1200px,95vw)] sm:h-[max(800px,95vh)] sm:max-w-5xl bg-white rounded-xl sm:rounded-2xl border-0 shadow-xl p-0 overflow-hidden flex flex-col">
        <DialogHeader className="px-4 sm:px-6 pt-4 pb-2 sm:pb-1">
          <DialogTitle className="font-heading text-xl sm:text-2xl text-brand">{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>

        <div className="w-full flex-1 min-h-0">
          <iframe
            title={iframeTitle}
            src={src}
            className="w-full h-full"
            style={{ border: 0 }}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
